<template>
  <ol v-if="hasDiscount" class="discount-info">
    <li v-for="discount in discountList" :key="discount.reference">
      {{ discount.publicName }}
      <template v-if="discount.validityEndDate">
        jusqu’au
        <time :datetime="discount.validityEndDate.toString()">
          {{ formatDate(discount.validityEndDate, 'dd/MM/yyyy') }}
        </time>
      </template>
    </li>
  </ol>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { formatDate } from '@b2ag/l10n'
import { useShop } from '@b2ag/catalog/src/useShop'

export default defineComponent({
  name: 'PDiscountInfo',
  props: {
    productId: String,
  },
  setup(props) {
    const { discountList } = useShop(props.productId)
    const hasDiscount = computed(() => discountList.value.length > 0)

    return {
      formatDate,
      hasDiscount,
      discountList,
    }
  },
})
</script>

<style lang="scss" scoped>
.discount-info {
  counter-reset: discount-refs 0;
  border-radius: var(--border-radius-2);
  background: var(--color-white);
  padding: var(--spacing-3);
  margin-top: var(--spacing-6);
  margin-bottom: var(--spacing-3);
  border: 4px solid var(--color-promo);
  color: var(--color-black);

  li::before {
    content: counter(discount-refs, asterisks);
    counter-increment: discount-refs;
  }
}
</style>
